module.exports = __webpack_public_path__ + "static/media/RepeatIconNew.aeda4192.svg";